module.exports = __webpack_public_path__ + "static/img/leftbot.4be9c09.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/icon/leftbot.jpg
// module id = 5G0m
// module chunks = 49